import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
export default class AdvancedSearchModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "query", '');
    _defineProperty(this, "matchType", 'all');
    _defineProperty(this, "titleOnly", false);
    _defineProperty(this, "author", '');
    _defineProperty(this, "tagSlug", '');
    _defineProperty(this, "dateRange", 'all');
    _defineProperty(this, "sort", '');
  }
  oninit(vnode) {
    super.oninit(vnode);

    // If an initial query was passed or is in the current search, pre-fill it
    const currentQ = this.attrs.initialQuery || (app.search && app.search.state && app.search.state.getValue ? app.search.state.getValue() : '') || m.route.param('q') || '';
    this.parseInitialQuery(currentQ);
  }
  parseInitialQuery(raw) {
    if (!raw) return;
    let q = raw;

    // Check titleOnly
    if (/\bin:title\b/i.test(q)) {
      this.titleOnly = true;
      q = q.replace(/\bin:title\b/gi, '').trim();
    }

    // Check author
    const authorMatch = q.match(/\bauthor:([^\s]+)/i);
    if (authorMatch) {
      this.author = authorMatch[1];
      q = q.replace(authorMatch[0], '').trim();
    }

    // Check tag
    const tagMatch = q.match(/\btag:([^\s]+)/i);
    if (tagMatch) {
      this.tagSlug = tagMatch[1];
      q = q.replace(tagMatch[0], '').trim();
    }

    // Check exact quotes
    const exactMatch = q.match(/^"([^"]+)"$/);
    if (exactMatch) {
      this.matchType = 'exact';
      this.query = exactMatch[1];
    } else {
      this.query = q;
    }
  }
  className() {
    return 'AdvancedSearchModal Modal--medium';
  }
  title() {
    return m("span", null, m("i", {
      className: "fas fa-sliders-h",
      style: {
        marginRight: '8px',
        color: 'var(--primary-color)'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.advanced_title') || 'Búsqueda Avanzada');
  }
  content() {
    const tags = (app.store.all('tags') || []).filter(t => t.position() !== null).sort((a, b) => (a.position() || 0) - (b.position() || 0));
    return m("div", {
      className: "Modal-body AdvancedSearchModal-body"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      className: "AdvancedSearchModal-label"
    }, m("i", {
      className: "fas fa-search",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.keywords_label') || 'Términos de búsqueda'), m("input", {
      type: "text",
      className: "FormControl AdvancedSearchModal-query",
      placeholder: "Ej: Nico Williams, sancet, fichajes, Europa...",
      value: this.query,
      oninput: e => {
        this.query = e.target.value;
      },
      oncreate: vnode => {
        if (this.query) vnode.dom.value = this.query;
      },
      autofocus: true
    })), m("div", {
      className: "Form-group AdvancedSearchModal-matchType"
    }, m("label", {
      className: "AdvancedSearchModal-sublabel"
    }, "Tipo de coincidencia:"), m("div", {
      className: "AdvancedSearchModal-radioGroup"
    }, m("label", {
      className: "radio-inline"
    }, m("input", {
      type: "radio",
      name: "matchType",
      value: "all",
      checked: this.matchType === 'all',
      onchange: () => {
        this.matchType = 'all';
      }
    }), m("span", null, " Todas las palabras (AND)")), m("label", {
      className: "radio-inline"
    }, m("input", {
      type: "radio",
      name: "matchType",
      value: "exact",
      checked: this.matchType === 'exact',
      onchange: () => {
        this.matchType = 'exact';
      }
    }), m("span", null, " Frase exacta (\"...\")")), m("label", {
      className: "radio-inline"
    }, m("input", {
      type: "radio",
      name: "matchType",
      value: "any",
      checked: this.matchType === 'any',
      onchange: () => {
        this.matchType = 'any';
      }
    }), m("span", null, " Cualquiera de las palabras")))), m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.titleOnly,
      onchange: val => {
        this.titleOnly = val;
      }
    }, app.translator.trans('nagusi-match-ratings.forum.search.title_only') || 'Buscar únicamente en los títulos de las discusiones')), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "AdvancedSearchModal-label"
    }, m("i", {
      className: "fas fa-user",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.author_label') || 'Escrito por un usuario concreto'), m("input", {
      type: "text",
      className: "FormControl AdvancedSearchModal-author",
      placeholder: "Nombre de usuario exacto...",
      value: this.author,
      oninput: e => {
        this.author = e.target.value;
      },
      oncreate: vnode => {
        if (this.author) vnode.dom.value = this.author;
      }
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "AdvancedSearchModal-label"
    }, m("i", {
      className: "fas fa-tag",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.tag_label') || 'En una etiqueta / categoría'), m("select", {
      className: "FormControl",
      value: this.tagSlug,
      onchange: e => {
        this.tagSlug = e.target.value;
      }
    }, m("option", {
      value: ""
    }, "Todas las categor\xEDas"), tags.map(tag => m("option", {
      value: tag.slug()
    }, tag.name())))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "AdvancedSearchModal-label"
    }, m("i", {
      className: "fas fa-calendar-alt",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.date_range_label') || 'Antigüedad'), m("select", {
      className: "FormControl",
      value: this.dateRange,
      onchange: e => {
        this.dateRange = e.target.value;
      }
    }, m("option", {
      value: "all"
    }, "Cualquier momento"), m("option", {
      value: "7d"
    }, "\xDAltima semana"), m("option", {
      value: "30d"
    }, "\xDAltimo mes"), m("option", {
      value: "90d"
    }, "\xDAltimos 3 meses"), m("option", {
      value: "365d"
    }, "\xDAltimo a\xF1o"))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "AdvancedSearchModal-label"
    }, m("i", {
      className: "fas fa-sort-amount-down",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('nagusi-match-ratings.forum.search.sort_label') || 'Ordenar resultados por'), m("select", {
      className: "FormControl",
      value: this.sort,
      onchange: e => {
        this.sort = e.target.value;
      }
    }, m("option", {
      value: ""
    }, "Relevancia (recomendado)"), m("option", {
      value: "-lastPostedAt"
    }, "\xDAltima actividad (m\xE1s recientes primero)"), m("option", {
      value: "-createdAt"
    }, "Fecha de creaci\xF3n (hilos nuevos primero)"), m("option", {
      value: "-commentCount"
    }, "M\xE1s comentados"))), m("div", {
      className: "Form-group AdvancedSearchModal-actions",
      style: {
        display: 'flex',
        gap: '10px',
        marginTop: '25px'
      }
    }, m(Button, {
      className: "Button Button--primary AdvancedSearchModal-submit",
      type: "submit",
      icon: "fas fa-search",
      style: {
        flex: '1',
        height: '44px',
        fontWeight: 'bold'
      }
    }, app.translator.trans('nagusi-match-ratings.forum.search.submit_button') || 'Buscar'), m(Button, {
      className: "Button Button--link",
      type: "button",
      onclick: this.resetFilters.bind(this),
      style: {
        color: 'var(--muted-color)'
      }
    }, "Limpiar")));
  }
  resetFilters() {
    this.query = '';
    this.matchType = 'all';
    this.titleOnly = false;
    this.author = '';
    this.tagSlug = '';
    this.dateRange = 'all';
    this.sort = '';
  }
  formatDateRange(days) {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    const pad = n => n < 10 ? '0' + n : '' + n;
    const formatDate = d => "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
    return "".concat(formatDate(start), "..").concat(formatDate(end));
  }
  onsubmit(e) {
    var _form$querySelector, _form$querySelector2;
    e.preventDefault();
    const form = e.target;
    const queryInput = form == null || (_form$querySelector = form.querySelector) == null ? void 0 : _form$querySelector.call(form, '.AdvancedSearchModal-query');
    const authorInput = form == null || (_form$querySelector2 = form.querySelector) == null ? void 0 : _form$querySelector2.call(form, '.AdvancedSearchModal-author');
    const parts = [];

    // 1. Process query
    const rawQ = queryInput ? queryInput.value : this.query;
    const cleanQ = (rawQ || '').trim();
    if (cleanQ) {
      if (this.matchType === 'exact') {
        parts.push("\"".concat(cleanQ.replace(/"/g, ''), "\""));
      } else {
        parts.push(cleanQ);
      }
    }

    // 2. Title only
    if (this.titleOnly) {
      parts.push('in:title');
    }

    // 3. Author
    const rawAuthor = authorInput ? authorInput.value : this.author;
    const cleanAuthor = (rawAuthor || '').trim();
    if (cleanAuthor) {
      parts.push("author:".concat(cleanAuthor));
    }

    // 4. Tag
    if (this.tagSlug) {
      parts.push("tag:".concat(this.tagSlug));
    }

    // 5. Date range
    if (this.dateRange !== 'all') {
      const daysMap = {
        '7d': 7,
        '30d': 30,
        '90d': 90,
        '365d': 365
      };
      const days = daysMap[this.dateRange];
      if (days) {
        parts.push("created:".concat(this.formatDateRange(days)));
      }
    }
    const fullQuery = parts.join(' ').trim();

    // Close the modal
    this.hide();

    // Route parameters
    const params = {};
    if (this.sort) {
      params.sort = this.sort;
    }
    if (this.tagSlug) {
      var _app$discussions;
      const queryWithoutTag = parts.filter(p => !p.startsWith('tag:')).join(' ').trim();
      if (queryWithoutTag) {
        params.q = queryWithoutTag;
      }
      if (app.search && app.search.state && typeof app.search.state.setValue === 'function') {
        app.search.state.setValue(queryWithoutTag || cleanQ);
      }
      (_app$discussions = app.discussions) == null || _app$discussions.clear();
      setRouteWithForcedRefresh(app.route('tag', _objectSpread({
        tags: this.tagSlug
      }, params)));
    } else {
      var _app$discussions2;
      if (fullQuery) {
        params.q = fullQuery;
      }
      if (app.search && app.search.state && typeof app.search.state.setValue === 'function') {
        app.search.state.setValue(cleanQ || fullQuery);
      }
      (_app$discussions2 = app.discussions) == null || _app$discussions2.clear();
      setRouteWithForcedRefresh(app.route('index', params));
    }
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/search/AdvancedSearchModal', AdvancedSearchModal);